import React, { useState } from "react";
import { FormikErrors } from "formik";

import { CustomProjectPropertyValueResponse } from "../../../../../api-models/response/CustomProjectPropertyValueResponse";
import { DataSection } from "../../../../../components/data-components/sections/DataSections";
import {
  Column,
  CustomPropertiesModel,
} from "../../../../../services/organization/ProjectPropertyStorage";
import { EditCustomPropertiesInColumns } from "../../../../../components/data-components/EditCustomProperties";

interface CustomProjectPropertiesProps {
  properties: CustomProjectPropertyValueResponse[];
  nestedFieldsPath?: string;
  values: { [id: string]: any };
  setFieldValue: (field: string, value: any) => Promise<void | FormikErrors<any>>;
  labelKey: string;
}

export function EditCustomPropertiesSection(props: CustomProjectPropertiesProps) {
  const { values, setFieldValue, nestedFieldsPath, properties, labelKey } = props;

  const [customPropertiesModel] = useState(() => CustomPropertiesModel.create({}));
  const columns: Column[] = customPropertiesModel.getMappedColumns(properties);

  return (
    <DataSection labelKey={labelKey}>
      {columns.map((column, key) => {
        return (
          <EditCustomPropertiesInColumns
            key={key}
            properties={column.properties}
            values={values}
            setFieldValue={setFieldValue}
            nestedFieldsPath={nestedFieldsPath}
          />
        );
      })}
    </DataSection>
  );
}
